<div id="successMdl" tabindex="-1">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content border-0">
            <div class="modal-body" style="border-radius: 20px">
                <div class="text-center">
                    <div class="d-flex justify-content-center">
                        <div style="width: 6rem; height: auto">
                          <span class="iconify" data-icon="carbon:information" style="font-size: 65px; color: rgb(221, 67, 67);"></span>
                        </div>
                    </div>

                    <div class="text-center my-3">
                        <p style="color:  rgb(221, 67, 67);">{{body}}</p>
                    </div>

                    <div class="my-3">
                        <button type="button" class="btn" [ngClass]="buttonClass" (click)="close()">
                            {{buttonText}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


